import { render, staticRenderFns } from "./DbQuery.vue?vue&type=template&id=76eca34c&scoped=true&"
var script = {}
import style0 from "./DbQuery.vue?vue&type=style&index=0&id=76eca34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eca34c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76eca34c')) {
      api.createRecord('76eca34c', component.options)
    } else {
      api.reload('76eca34c', component.options)
    }
    module.hot.accept("./DbQuery.vue?vue&type=template&id=76eca34c&scoped=true&", function () {
      api.rerender('76eca34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/DbQuery.vue"
export default component.exports